import React from "react";

import { SectionTitle } from "@components/SectionTitle";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { IdentifiersFilter } from "./IdentifiersFilter";
import { IdentifiersTable } from "./IdentifiersTable";

interface FieldDeviceIdentifiersProps {
  device: FieldDevice;
}

export const FieldDeviceIdentifiers: React.FC<FieldDeviceIdentifiersProps> = ({
  device
}) => {
  return (
    <>
      <SectionTitle>Device Identifiers</SectionTitle>
      <IdentifiersFilter>
        {({ values }) => {
          return <IdentifiersTable deviceId={device?.id} filter={values} />;
        }}
      </IdentifiersFilter>
    </>
  );
};
